import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { content } from '../data/content';
import { FaSun, FaMoon, FaGlobe } from 'react-icons/fa';

const Header = () => {
  const { language, setLanguage, direction } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const currentContent = content[language];
  const navigate = useNavigate();
  const location = useLocation();
  const [langMenu, setLangMenu] = useState(false);

  const headerTextColor = '#fff';
  const headerTextShadow = '0 2px 8px rgba(0,0,0,0.18)';

  return (
    <header className="header fade-in" style={{ direction, fontFamily: language === 'ar' ? 'Tajawal, Cairo, Arial, sans-serif' : 'Montserrat, Arial, sans-serif' }}>
      <div className="header-content">
        <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
          <img 
            src="/logo.png" 
            alt="Shifaa Logo" 
            className="header-logo" 
            style={{
              background: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '12px',
              padding: '8px',
              border: '2px solid rgba(255, 255, 255, 0.8)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
              backdropFilter: 'blur(10px)'
            }}
          />
          <div className="header-text">
            <h1 style={{ 
              fontFamily: language === 'ar' ? 'Tajawal, Cairo, Arial, sans-serif' : 'Montserrat, Arial, sans-serif', 
              color: headerTextColor, 
              textShadow: headerTextShadow,
              fontSize: '1.8em',
              margin: 0
            }}>{language === 'ar' ? 'شفاء' : 'Shifaa'}</h1>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, position: 'relative' }}>
          <button className="contact-icon" style={{
            fontSize: '1.2em', 
            padding: 0, 
            width: 44, 
            height: 44,
            background: 'linear-gradient(135deg, #05668D 0%, #028090 50%, #00A896 100%)',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            color: 'white',
            fontWeight: 'bold',
            boxShadow: '0 4px 16px rgba(5, 102, 141, 0.4)'
          }} onClick={() => setLangMenu(v => !v)} title={language === 'ar' ? 'تغيير اللغة' : 'Change Language'}>
            <FaGlobe />
          </button>
          {langMenu && (
            <div style={{ 
              position: 'absolute', 
              top: 48, 
              left: direction === 'rtl' ? 'unset' : 0, 
              right: direction === 'rtl' ? 0 : 'unset', 
              background: 'linear-gradient(135deg, #05668D 0%, #028090 50%, #00A896 100%)',
              border: '2px solid rgba(255, 255, 255, 0.4)', 
              borderRadius: 12, 
              zIndex: 100, 
              minWidth: 100, 
              boxShadow: '0 8px 32px rgba(5, 102, 141, 0.4)',
              backdropFilter: 'blur(15px)',
              padding: '4px'
            }}>
              <div style={{ 
                padding: '10px 16px', 
                cursor: 'pointer', 
                fontFamily: 'Tajawal, Cairo, Arial, sans-serif', 
                color: language === 'ar' ? '#F0F3BD' : 'white',
                fontWeight: language === 'ar' ? 'bold' : 'normal',
                borderRadius: 8,
                background: language === 'ar' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                transition: 'all 0.3s ease'
              }} onClick={() => { setLanguage('ar'); setLangMenu(false); }}>العربية</div>
              <div style={{ 
                padding: '10px 16px', 
                cursor: 'pointer', 
                fontFamily: 'Montserrat, Arial, sans-serif', 
                color: language === 'en' ? '#F0F3BD' : 'white',
                fontWeight: language === 'en' ? 'bold' : 'normal',
                borderRadius: 8,
                background: language === 'en' ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                transition: 'all 0.3s ease'
              }} onClick={() => { setLanguage('en'); setLangMenu(false); }}>English</div>
            </div>
          )}
          <button className="contact-icon" style={{
            fontSize: '1.2em', 
            padding: 0, 
            width: 44, 
            height: 44,
            background: 'linear-gradient(135deg, #05668D 0%, #028090 50%, #00A896 100%)',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            color: 'white',
            fontWeight: 'bold',
            boxShadow: '0 4px 16px rgba(5, 102, 141, 0.4)'
          }} onClick={toggleTheme} title={theme === 'dark' ? (language === 'ar' ? 'وضع النهار' : 'Light Mode') : (language === 'ar' ? 'وضع الليل' : 'Dark Mode')}>
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;